<p-table styleClass="p-datatable-striped" [columns]="myEscalationsCols" [value]="csrOverridesQueue" #dt>
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50"
                    placeholder="Filter Results..."
                    (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let column of columns" [pSortableColumn]="column.field">{{column.header}}<p-sortIcon
                    [field]="column.field"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <td *ngFor="let column of myEscalationsCols">{{item[column.field]}}</td>
        </tr>
    </ng-template>
</p-table>